<ng-template >
    {{ src }} 
</ng-template>